<!-- Composer: log an interaction -->
<div class="activity-composer" *ngIf="auth.hasPermission('Customer.Manage')">
  <div class="composer-row">
    <mat-form-field appearance="outline" class="composer-type">
      <mat-label>Type</mat-label>
      <mat-select [(ngModel)]="activityForm.activityType">
        <mat-option *ngFor="let t of activityTypes" [value]="t">{{ t }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="composer-subject">
      <mat-label>Subject</mat-label>
      <input matInput [(ngModel)]="activityForm.subject" maxlength="255"
             placeholder="What happened?" (keyup.enter)="logActivity()">
    </mat-form-field>
  </div>
  <mat-form-field appearance="outline" class="composer-body">
    <mat-label>Details (optional)</mat-label>
    <textarea matInput [(ngModel)]="activityForm.body" rows="2"></textarea>
  </mat-form-field>
  <div class="composer-row">
    <app-date-field class="composer-type" label="Follow-up on (optional)" [(ngModel)]="activityForm.followUpOn"></app-date-field>
    <app-time-field class="composer-type" label="At (optional)" [(ngModel)]="activityForm.followUpTime"
                    [disabled]="!activityForm.followUpOn"></app-time-field>
  </div>
  <div class="composer-actions">
    <span class="br-alert br-alert--danger activity-error" *ngIf="activityError">{{ activityError }}</span>
    <button type="button" class="br-btn br-btn--primary" (click)="logActivity()"
            [disabled]="loggingActivity || !activityForm.subject.trim()">
      {{ loggingActivity ? 'Logging…' : 'Log activity' }}
    </button>
  </div>
</div>

<!-- Timeline -->
<p *ngIf="activitiesLoading && activities.length === 0" class="empty-state">Loading…</p>
<p *ngIf="!activitiesLoading && activities.length === 0" class="empty-state">
  No activity yet. Log the first interaction above.
</p>

<div class="activity-timeline">
  <div class="activity-item" *ngFor="let a of activities" [class.activity-system]="a.isSystem">
    <br-icon class="activity-icon">{{ activityIcon(a.activityType) }}</br-icon>
    <div class="activity-body">
      <div class="activity-head">
        <span class="br-badge br-badge--neutral activity-type-chip">{{ a.activityType }}</span>
        <span class="activity-subject">{{ a.subject }}</span>
        <span class="activity-when">{{ a.occurredAt | date:'medium' }}</span>
        <button mat-icon-button class="activity-delete" *ngIf="auth.hasPermission('Customer.Manage')"
                (click)="deleteActivity(a)" matTooltip="Delete">
          <br-icon>delete</br-icon>
        </button>
      </div>
      <div class="activity-text" *ngIf="a.body">{{ a.body }}</div>
      <div class="activity-followup" *ngIf="a.followUpOn">
        <ng-container *ngIf="!a.followUpCompletedAt">
          <br-icon class="followup-icon">event</br-icon>
          <span>Follow up on {{ followUpDateTime(a) | date:(a.followUpTime ? 'MMM d, y, h:mm a' : 'mediumDate') }}</span>
          <button type="button" class="br-btn br-btn--link br-btn--sm followup-done"
                  *ngIf="auth.hasPermission('Customer.Manage')" (click)="completeFollowUp(a)">
            Mark done
          </button>
        </ng-container>
        <span *ngIf="a.followUpCompletedAt" class="followup-completed">
          <br-icon class="followup-icon">check_circle</br-icon>
          Follow-up completed
        </span>
      </div>
      <div class="activity-meta">
        <span *ngIf="a.isSystem" class="activity-system-tag">System</span>
        <span *ngIf="a.createdByUserName">by {{ a.createdByUserName }}</span>
      </div>
    </div>
  </div>
</div>

<div class="activity-more" *ngIf="activities.length < activityTotal">
  <button type="button" class="br-btn br-btn--outline-secondary" (click)="loadMoreActivities()" [disabled]="activitiesLoading">
    Load more ({{ activities.length }} / {{ activityTotal }})
  </button>
</div>
